import { createRouter, createWebHistory } from 'vue-router';

// Importation des vues
/*import AccueilView from '../views/AccueilView.vue';
import QuestionnaireView from '../views/QuestionnaireView.vue';
import AdhesionValideeView from '../views/AdhesionValideeView.vue';

const routes = [
  {
    path: '/',
    name: 'Accueil',
    component: AccueilView
  },
  {
    path: '/questionnaire',
    name: 'Questionnaire',
    component: QuestionnaireView
  },
  {
    path: '/adhesionValidee',
    name: 'AdhesionValidee',
    component: AdhesionValideeView
  }
];*/

// On ne garde en statique que la page d'accueil (pour un affichage immédiat)
import AccueilView from '../views/AccueilView.vue';

const routes = [
  {
    path: '/',
    name: 'Accueil',
    component: AccueilView
  },
  {
    path: '/questionnaire',
    name: 'Questionnaire',
    // Importation dynamique : le fichier ne sera chargé qu'au clic
    component: () => import(/* webpackChunkName: "questionnaire" */ '../views/QuestionnaireView.vue')
  },
  {
    path: '/adhesionValidee',
    name: 'AdhesionValidee',
    component: () => import(/* webpackChunkName: "adhesion" */ '../views/AdhesionValideeView.vue')
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;
